/* eslint-disable react-hooks/exhaustive-deps */
import { ordersFilterArray, OrderStatusEnum } from 'common/enums';
import formatDate from 'common/helpers/formatDate';
import { useActions } from 'common/hooks/useActions';
import * as T from 'common/types';
import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import PaginationApp from 'components/pagination';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ReactSVG } from 'react-svg';
import * as S from './styles';

interface IProps {
  menuList: { list: T.Pages.CafeteriaListItem[]; totalPages: number };
  loading: boolean;
}

export default function CafeteriaOrdersTable({ menuList, loading }: IProps) {
  const { ordersListRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 10,
    keyword: '',
    status: ''
  });
  const navigate = useNavigate();
  const fetchData = () => {
    ordersListRequestAction(meta);
  };
  useEffect(() => {
    fetchData();
  }, [meta]);
  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };
  const handleChangeTake = (page_size: number) => {
    setMeta({ ...meta, page_size });
  };
  const renderStatusName = (status: string) => {
    let newText: string = '';
    // eslint-disable-next-line array-callback-return
    OrderStatusEnum.map((item: any) => {
      if (item.id === status) newText = item.title;
    });
    return newText;
  };
  const statusColorHandler = (status: string) => {
    switch (status) {
      case 'Delivered':
        return '#1DBAAF';
      case 'Pending':
        return '#FF9C72';
      case 'Cancelled':
        return '#FF6464';
      default:
        break;
    }
  };
  const handleFilter = (field: string, val: string | number) => {
    setMeta({ ...meta, page: 1, [field]: val });
  };

  function getFoodTitles(items: any) {
    if (!Array.isArray(items)) {
      return [];
    }
    return items.map((item) => item.food?.title).filter((title) => title);
  }

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox
            onChange={(e) => handleFilter('keyword', e)}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
            value={meta.keyword}
          />
          <S.FilterButoons>
            <S.Button onClick={() => handleFilter('status', '')} className={meta.status === '' ? 'active' : ''}>
              All
            </S.Button>
            {ordersFilterArray.map((item) => (
              <S.Button
                onClick={() => handleFilter('status', item.id)}
                className={meta.status === item.id ? 'active' : ''}
              >
                {item.title}
              </S.Button>
            ))}
          </S.FilterButoons>
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, title: 'Orders', dir: 'left', width: '25%' },
            { id: 2, title: 'User', dir: 'left', width: '20%' },
            { id: 3, title: 'Floor', width: '5%' },
            { id: 4, title: 'Teaboy', width: '20%' },
            { id: 5, title: 'Time and Date', width: '15%' },
            { id: 6, title: 'Status', width: '10%' },
            { id: 7, title: '', width: '5%' }
          ]}
          style={{ minWidth: 'auto' }}
          data={menuList?.list}
          loading={loading}
          altanfeethiFields={{
            orders: (item: T.Pages.OrdersList) => (
              <S.ImageContainer className="text-left">
                <S.Image src={item?.cart == null ? '/images/call-the-waiter.png' : item?.image} />

                <S.Div>
                  {item.cart
                    ? getFoodTitles(item.cart.items).join(', ').substring(0, 100) +
                    (getFoodTitles(item.cart.items).join(', ').length > 100 ? ' ...' : '')
                    : 'Call the Waiter'}
                </S.Div>

              </S.ImageContainer>
            ),
            user: (item: T.Pages.OrdersList) => <S.Div className="text-left">{item?.user?.displayName}</S.Div>,
            floor: (item: T.Pages.OrdersList) => <S.Div className="">{item?.floor?.name}</S.Div>,
            teaboy: (item: T.Pages.OrdersList) => <S.Div className="">{item?.teaBoy?.user?.displayName}</S.Div>,
            timeAndDate: (item: T.Pages.OrdersList) => <S.Div className="">{formatDate(item?.localDate)}</S.Div>,
            status: (item: T.Pages.OrdersList) => (
              <S.Div style={{ color: statusColorHandler(renderStatusName(item?.status)) }}>
                {renderStatusName(item?.status)}
              </S.Div>
            ),
            detail: (item: T.Pages.OrdersList) => (
              <S.Div style={{ cursor: 'pointer' }} onClick={() => navigate(`/panel/cafeteria/orders/${item?.id}`)}>
                <ReactSVG src="/icons/eye-outline.svg" />
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {menuList?.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * menuList.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={menuList.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangeTake}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
